import type { Component, InjectionKey, Slots } from 'vue';
import type { BlockDefinition, BlockSerialized } from '#layers/block-engine/types/block';
import type { UseBlockRenderPropsOptions } from '#layers/block-engine/utils/block/props';

/**
 * Information to render child blocks manually inside other blocks.
 */
export interface BlockChildRenderContext extends UseBlockRenderPropsOptions {
	block: BlockSerialized;
	childrenBlocks: Record<string, BlockSerialized | BlockDefinition>;
	blockRenderComponents: Record<string, Component>;
	/** Slots supplied to serialized root, used by nested slot outlets. */
	rootSlots: Slots;
}

export const blockChildRenderContextKey = Symbol('blockChildRenderContext') as InjectionKey<BlockChildRenderContext>;
